export const PAYMENT_TYPE_OPTIONS = [
  {
    label: "Bank Transfer",
    value: "Wire",
  },
  {
    label: "CC Authorization",
    value: "ccAuthorization",
    type: "client",
  },
  {
    label: "Credit Card",
    value: "CC",
  },
  {
    label: "Funds on File (General)",
    value: "Account",
  },
  {
    label: "Funds on File (Membership)",
    value: "MembershipDollars",
  },
  {
    label: "Membership Credits",
    value: "MembershipCredits",
  },
  {
    label: "Other",
    value: "other",
    type: "invoice",
  },
];
export const CLIENT_PAYMENT_TYPE_OPTIONS = PAYMENT_TYPE_OPTIONS.filter(({ type }) => !type || type === "client");
export const OPERATOR_PAYMENT_TYPE_OPTIONS = PAYMENT_TYPE_OPTIONS.filter(({ type }) => !type || type === "operator");

export const INVOICE_PAYMENT_TYPE_OPTIONS = PAYMENT_TYPE_OPTIONS.filter(({ type }) => !type || type === "invoice");

const formatPaymentType = (paymentType) =>
  PAYMENT_TYPE_OPTIONS.find(({ value }) => value === paymentType)?.label || paymentType;

export default formatPaymentType;
